export const PROGRAM_OST = 'ost'
export const GRADES_k1 = 'k1'
export const GRADES_23 = '23'
export const GRADES_45 = '45'
